import { render } from "src/website-apps/shared/utils/render";
import { CategoryGroupingRoot } from "./root";

render(<CategoryGroupingRoot />);
